import Immutable from 'seamless-immutable'

import { MINWAGE_SET_WAGES_BY_JURISDICTION } from './actionTypes'

const initialState = Immutable({ notifications: [] })

export default function State(state = initialState, action) {
  switch (action.type) {
    case MINWAGE_SET_WAGES_BY_JURISDICTION:
      state = Immutable.set(state, 'wagesByJurisdiction', action.payload)
      break
    default:
      break
  }

  return state
}
